import InputBase from '@mui/material/InputBase'
import Stack from '@mui/material/Stack'
import MinusIcon from '../../../assets/icons/svg/MinusIcon.svg?react'
import PlusIcon from '../../../assets/icons/svg/PlusIcon.svg?react'

interface QtyInputProps {
    quantity: number
    setQuantity: (quantity: number) => void
    increase: () => void
    decrease: () => void
}
const QtyInput = ({ quantity, setQuantity, increase, decrease }: QtyInputProps) => {
    return (
        <Stack direction={'row'} alignItems={'center'} padding={'5px 12px'} borderRadius={'20px'} bgcolor={'#E9F1FA'} height={'25px'} flex={1}>
            <Stack onClick={decrease} sx={{ cursor: 'pointer', width: '15px', height: '100%', justifyContent: 'center', alignItems: 'flex-start' }}>
                <MinusIcon />
            </Stack>
            <Stack minWidth={'10px'} height={'15px'} justifyContent={'center'} alignItems={'center'} width={'fit-content'}>
                <InputBase
                    value={quantity}
                    onChange={e => setQuantity(Number(e.target.value))}
                    sx={{
                        input: {
                            textAlign: 'center',
                            fontSize: '14px',
                            padding: '0px',
                            height: '25px',
                            border: 'none',
                            fontFamily: 'Poppins',
                            fontWeight: 600,
                            color: 'rgba(0, 59, 111, 1)'
                        },
                        '.MuiInputBase-root::before': { content: 'none', border: 'none' },
                        '&.MuiInputBase-root': { backgroundColor: 'transparent', border: 'none', minWidth: '10px' },
                        '& .MuiInputBase-input': { backgroundColor: '#E9F1FA', minWidth: '10px' }
                    }}
                />
            </Stack>
            <Stack onClick={increase} sx={{ cursor: 'pointer', width: '15px', height: '100%', justifyContent: 'center', alignItems: 'flex-end' }}>
                <PlusIcon />
            </Stack>
        </Stack>
    )
}

export default QtyInput
